/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BedroomInputs */

const cs_enum_bedroom = /** @type {(inputs: Enum_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ložnice`)
};

const en_enum_bedroom = /** @type {(inputs: Enum_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedroom`)
};

/**
* | output |
* | --- |
* | "Bedroom" |
*
* @param {Enum_BedroomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_bedroom = /** @type {((inputs?: Enum_BedroomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BedroomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_bedroom(inputs)
	return cs_enum_bedroom(inputs)
});